import React from "react";
import { Box } from "@mui/material";
import Sidebar from "../Sidebar";
import {
  MainLayoutContainer,
  MainContentArea,
  MainSidebarArea,
} from "./MainLayout.styled";

type MainLayoutProps = {
  children: React.ReactNode;
};

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <MainLayoutContainer>
      <Box sx={{ display: "flex", flex: 1 }}>
        <MainSidebarArea>
          <Sidebar />
        </MainSidebarArea>

        <MainContentArea>{children}</MainContentArea>
      </Box>
    </MainLayoutContainer>
  );
};

export default MainLayout;
